<template>
  <layout :breadcrumb="breadcrumb">
    <b-tabs content-class="mt-3" lazy>
      <b-tab :title="tab.title" v-for="tab in pageData.tabs" v-bind:key="tab.viewId">
        <page-tab-content :viewId="tab.viewId" :viewType="tab.viewType" />
      </b-tab>
    </b-tabs>
  </layout>
</template>

<script>
import PageTabContent from "./PageTabContent.vue";

import Api from "@/api";

export default {
  components: { PageTabContent },
  data: () => ({
    pageData: {},
  }),
  created() {
    this.loadData();

    this.$eventHub.$on("error", (err) => {
      this.loadData();
    });

    this.$eventHub.$on("localeChanged", () => {
      this.pageData = {};
      this.loadData();
    });
  },
  methods: {
    loadData() {
      this.isLoading = true;

      Api.getMenuById(this.$route.params.id)
        .then((response) => this.pageData = response)
        .catch((error) => this.$eventHub.emit(error))
        .finally(() => this.isLoading = false);
    }
  },
  computed: {
    breadcrumb() {
      return [
        {
          text: this.$t('homePage'),
          to: "/",
        },
        {
          text: this.pageData.title
        }
      ];
    }
  },
}
</script>